module.exports = __webpack_public_path__ + "img/op_img-carrusel-empresas-mobile.723e189.jpg";